var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1613 3.81607C15.8344 3.47767 15.2902 3.47767 14.9518 3.81607C14.6248 4.14303 14.6248 4.6872 14.9518 5.0134L21.0848 11.1464H0.846745C0.374976 11.1472 0 11.5221 0 11.9939C0 12.4657 0.374976 12.8528 0.846745 12.8528H21.0848L14.9518 18.9744C14.6248 19.3128 14.6248 19.8577 14.9518 20.1839C15.2902 20.5223 15.8351 20.5223 16.1613 20.1839L23.7462 12.599C24.0846 12.2721 24.0846 11.7279 23.7462 11.4017L16.1613 3.81607Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.968a2176c372391486f336bcfcd85757.svg";
export { ForwardRef as ReactComponent };